<template>
    <div style='font-family: "Inter", "Noto Sans", sans-serif !important;'>
        <section class="message-popup " :class="{ 'popup-show': visible }">
            <span class="iconfont icon-close" @click="close"></span>
            <div class="message-popup-title">{{ $t('message.与我们联系') }}</div>
            <div class="message-popup-info" v-if="$t('message.专属客户经理将尽快联系您')">{{ $t('message.专属客户经理将尽快联系您') }}</div>

            <div class="form-box contact-us">
                <div class="form-group form-group-flex">
                    <input type="text" class="input-field" id="name" name="name" v-model="infoData.name"
                        :placeholder="$t('CFooters.contact.name')">
                    <div class="gender-selector">
                        <button type="button" class="gender-btn select-label"
                            v-for="(item, index) in $t('CFooters.contact.sexList')"
                            :class="{ 'select-label--active': sexIndex === index }" @click="changeSix(index)">{{
                                item.label
                            }}</button>
                    </div>
                </div>
                <div class="form-group">
                    <input type="email" id="phone-email" name="email" v-model="infoData.call" class="input-field"
                        :placeholder="$t('CFooters.contact.email')">
                </div>
                <div class="form-group ">
                    <div class="captcha-container form-group-flex">
                        <input id="verify" v-model="code" type="text" class="input-field"
                            :placeholder="$t('CFooters.contactUs.code')">
                        <div class="verify-code" @click="refreshCode"><ss-code :identifyCode="identifyCode"></ss-code>
                        </div>
                    </div>
                </div>
                <button type="submit" class="contact-submit" id="contact-submit" @click="getContact">{{
                    $t('message.立即参与')
                    }}</button>
            </div>
        </section>
        <div class="popup-bg" @click="close" :class="{ 'popup-bg-show': visible }"></div>
    </div>
</template>

<script>
// 全局变量记录滚动位置和滚动条宽度
let scrollPosition = 0;
let scrollbarWidth = 0;
// 阻止移动端触摸滚动
function preventTouchScroll(e) {
    if (e.target === document.body || e.target === document.documentElement) {
        e.preventDefault();
    }
}

// 获取滚动条宽度
function getScrollbarWidth() {
    // 创建测量元素
    const scrollDiv = document.createElement("div");
    scrollDiv.style.width = "100px";
    scrollDiv.style.height = "100px";
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    document.body.appendChild(scrollDiv);

    // 计算宽度差
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // 移除测量元素
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
}



import md5 from 'js-md5';
export default {
    props: {
        mode: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            visible: false,
            sexIndex: 0,
            infoData: {
                call: '',
                name: ''
            },
            code: null,
            identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
            identifyCode: "", //验证码图片内容
        }
    },
    mounted() {
        // 初始化验证码
        this.identifyCode = "";
        //参数：（1）随机串内容。（2）验证码显示位数
        this.makeCode(this.identifyCodes, 4);


        // 计算滚动条宽度
        scrollbarWidth = getScrollbarWidth();
    },
    methods: {
        show() {
            this.visible = true;
            // 记录当前滚动位置
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            scrollbarWidth = getScrollbarWidth();
            // 禁止滚动并处理滚动条
            document.body.classList.add("body-no-scroll");
            document.body.style.top = `-${scrollPosition}px`;
            // 补偿滚动条宽度，防止页面跳动
            if (scrollbarWidth > 0) {
                document.body.style.paddingRight = `${scrollbarWidth}px`;
            }

            // 处理移动端触摸事件
            document.addEventListener("touchmove", preventTouchScroll, {
                passive: false,
            });
        },
        close() {
            this.visible = false;
            this.code = null
            this.infoData = {
                call: '',
                name: ''
            }

            // 恢复滚动
            document.body.classList.remove("body-no-scroll");
            document.body.style.removeProperty("top");
            document.body.style.removeProperty("padding-right");

            // 立即跳转到原位置（无动画）
            window.scrollTo({
                top: scrollPosition,
                behavior: "instant",
            });

            // 移除移动端触摸事件监听
            document.removeEventListener("touchmove", preventTouchScroll);
        },
        // 重置验证码
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        //获取验证码的值
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                //通过循环获取字符串内随机几位
                this.identifyCode +=
                    this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
            }
        },
        //随机数字：用于当角标拿字符串的值
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        getContact() {
            let infoData = {
                ...this.infoData
            }

            if (!infoData.name) return this.$toast(this.$t('CFooters.contact.tips1'));
            if (!infoData.call) return this.$toast(this.$t('CFooters.contact.tips2'));
            if (this.identifyCode != this.code) {
                // this.code = null
                return this.$toast(this.$t('CFooters.contact.tips4'));
            }
            let checksum = md5(infoData.call + "YISENCE")
            let parms = 'name=' + infoData.name + '&sex=' + this.$t('CFooters.contact.sexList')[this.sexIndex].label +
                '&mobile=' + infoData.call + '&checksum=' + checksum
            let time = new Date().getMilliseconds()
            let checkSum1 = md5(infoData.name + infoData.call + time + "YISENCE")

            this.$http('/ebc/api/setContact/run', {
                name: infoData.name,
                contact: infoData.call,
                date: time,
                checkSum: checkSum1
            }).then(res => {
                this.$toast(this.$t('CFooters.contact.tips3'))
                this.code = null
                this.infoData = {
                    call: '',
                    name: ''
                }
            })
        },
        changeSix(index) {
            this.sexIndex = index
        },
    }
}

</script>

<style lang="scss">
.s-canvas {
    border-radius: 4rem;
    overflow: hidden;
}

/* 禁止滚动时的body样式 */
.body-no-scroll {
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
}

.message-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 100vh);
    opacity: 0;
    padding: 24rem 48rem;
    font-family: "Inter", "Noto Sans", sans-serif !important;
    background-color: #fff;
    z-index: 9999999999;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    border-radius: var(--Corner-Radius-RC12, 12rem);
    /* transition: all 0.47s cubic-bezier(0.68, -0.55, 0.265, 1.55); */
}

.popup-bg {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.64);
    z-index: 999999999;
}

.popup-bg-show {
    display: block;
}

.popup-show {
    transform: translate(-50%, -50%);
    opacity: 1;
}

.message-popup .icon-close {
    position: absolute;
    right: 32rem;
    top: 32rem;
    font-size: 24rem;
    color: #858585;
    cursor: pointer;
}

.message-popup-title {
    color: var(--Text-Primary, #000);
    font-size: 32rem;
    font-style: normal;
    font-weight: 700;
    line-height: 40rem;
    width: 400rem;
}

.message-popup-info {
    margin-top: 16rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem;
    width: 464rem;
}

.message-popup .icon-arrow {
    width: 24rem;
}

.message-popup .form-box {
    margin-top: 48rem;
    width: 464rem;
}


.message-popup .form-group {
    margin-bottom: 16rem;
    position: relative;
}

.message-popup .form-group-flex {
    display: flex;
    align-items: center;
    gap: 24rem;
}

.message-popup .input-field {
    width: 100%;
    height: 48rem;
    line-height: 48rem;
    padding: 13rem 16rem;
    background: transparent;
    border: none;
    border-bottom: none;
    /* 1px solid var(--Neutral-Divider_Regular, rgba(0, 0, 0, 0.08)); */
    color: var(--Text-Primary, #000);
    font-size: 16rem;
    outline: none;
    border-radius: var(--Corner-Radius-RC08, 8rem);
    background: var(--Neutral-BG_B, #f7f7f7);
}

.message-popup .gender-selector {
    display: flex;
    flex-shrink: 0;
}

.message-popup .gender-btn {
    position: relative;
    padding: 5rem 15rem 5rem 24rem;
    background: transparent;
    color: var(--Text-Primary, #000);
    cursor: pointer;
    font-size: 16rem;
}

.message-popup .gender-btn::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 16rem;
    height: 16rem;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 50%;
    transform: translateY(-50%);
}

.message-popup .gender-btn.select-label--active::before {
    border: 5rem solid var(--Text-Primary, #a52933);
}

.message-popup .captcha-container {
    display: flex;
    gap: 10rem;
    align-items: center;
}

.message-popup .captcha-code {
    padding: 5rem 10rem;
    background: rgba(255, 255, 255, 0.9);
    color: #333;
    border-radius: 4rem;
}

.message-popup .contact-submit {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 48rem;
    padding: 0 24rem;
    gap: 8rem;
    border-radius: 24rem;
    background: var(--Brand-Secondary-Red, #a52933);
    color: #fff;
    text-align: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1;
    margin-top: 30rem;
    width: 100%;
}

.message-popup .contact-submit:hover {
    background: var(--Functional-Active-Hover, #cc333f);
    color: #fff;
}

.message-popup .contact-submit:active {
    background: var(--Functional-Active-Pressed, #7b1e26);
    color: #fff;
}

.message-popup ::placeholder {
    color: var(--Text-Tertiary, rgba(0, 0, 0, 0.48));
}


@media (max-width: 996px) {
    .message-popup .p1 {
        font-size: 48rem;
        line-height: 1.4;
        margin-bottom: 0;
    }

    .message-popup .input-field {
        height: 96rem;
        font-size: 14px;
        padding: 0 32rem;
        border-radius: 16rem;
    }

    .message-popup .gender-btn {
        font-size: 14px;
    }

    .message-popup .gender-btn {
        padding: 5rem 15rem 5rem 38rem;
    }

    .message-popup .gender-btn::before {
        width: 28rem;
        height: 28rem;
    }

    .message-popup .gender-btn.select-label--active::before {
        border: 10rem solid var(--Text-Primary, #a52933);
    }

    .message-popup .contact-submit {
        height: 96rem;
        border-radius: 48rem;
        font-size: 32rem;
        font-style: normal;
        font-weight: 500;
        line-height: 56rem;
        padding: 0 48rem;
        width: 100%;
    }

    .message-popup .form-group {
        margin-bottom: 22px;
    }


    .message-popup {
        padding: 64rem 32rem 96rem;
        width: 100vw;
        flex-direction: column;
        align-items: center;
        gap: 64rem;
        position: fixed;
        top: unset;
        bottom: 0;
        left: 0;
        transform: translate(0, 100%);
        border-radius: 48rem 48rem 0 0;
        transition: all 0.3s ease-out;
    }

    .message-popup-title {
        text-align: center;
        font-size: 48rem;
        line-height: 72rem;
        width: 100%;
    }

    .message-popup-info {
        text-align: center;
        font-size: 24rem;
        line-height: 40rem;
        width: 100%;
    }

    .popup-show {
        transform: translate(0, 0);
        opacity: 1;
    }

    .message-popup .icon-arrow {
        width: 48rem;
    }

    .message-popup .icon-close {
        font-size: 34rem;
    }

    .s-canvas {
        border-radius: 16rem;
    }

    .message-popup .form-box {
        width: 100%;
        padding-bottom: 0px;
    }
}
</style>
